<template>
  <q-dialog
    :visible="isVisible"
    :title="title"
    width="700px"
    :innerScroll="false"
    :loading="loadingBth"
    @close="onCancel"
    @cancel="onCancel"
    @confirm="onConfirm"
  >
    <el-form ref="addForm" :model="addForm" :rules="rules" size="mini" v-loading="loading" label-position="left" class="content">
      <el-row>
        <el-col :span="24">
          <el-col :span="10">
            <el-form-item label="消息名称:" prop="priceRatio">
              <span>{{ addForm.messageTitle }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="14">
            <el-form-item label="通知对象:" prop="priceRatio" label-width="120px">
              <el-select
                v-model="addForm.label"
                ref="mySelect"
                filterable
                multiple
                collapse-tags
                :filter-method="filterMethod"
                style="margin-bottom: 10px"
                show-word-limit
                @change="labelChange"
              >
                <el-option :value="treeDataValue" style="height: auto">
                  <el-tree
                    ref="tree"
                    :data="nodeData"
                    accordion
                    show-checkbox
                    node-key="nodeId"
                    :props="defaultProps"
                    :filter-node-method="filterNode"
                    :default-expanded-keys="treeExpandDate"
                    @check-change="checkChange"
                  >
                    <span slot-scope="{ data }">
                      <span @click.stop="() => handleNodeClick(data)">{{ data.nodeName }}</span>
                    </span>
                  </el-tree>
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="通知频率:" prop="priceRatio">
              <span>{{ addForm.notificationFrequency }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="14">
            <el-form-item label="未处理再次通知:" prop="notificationAgain" label-width="120px">
              <el-select v-model="addForm.notificationAgain" filterable>
                <el-option v-for="item in ['/', '1小时', '3小时', '6小时', '24小时', '48小时', '72小时']" :label="item" :key="item" :value="item"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-col>
      </el-row>
      <el-form-item label="消息通知内容:" style="margin-bottom: 10px"> </el-form-item>
      <div>
        <el-input v-model.trim="addForm.messageContent" type="textarea" maxlength="200" show-word-limit :autosize="{ minRows: 6, maxRows: 10 }"></el-input>
      </div>
      <el-form-item label="状态:" prop="status" style="margin-top: 10px">
        <el-radio v-model="addForm.status" label="启用">启用</el-radio>
        <el-radio v-model="addForm.status" label="停用">停用</el-radio>
      </el-form-item>
    </el-form>
  </q-dialog>
</template>

<script>
export default {
  name: "addEdit",
  props: {
    // 重新对外暴露visible，控制显示隐藏
    visible: {
      type: Boolean,
      default: false,
    },
    rowData: Object,
  },
  computed: {
    // 通过计算属性，对.sync进行转换，外部也可以直接使用visible.sync
    isVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit("update:visible", val);
      },
    },
    title() {
      return "编辑";
    },
  },
  data() {
    return {
      loading: false,
      loadingBth: false,
      addForm: {},
      rules: {},
      treeDataValue: [],
      nodeData: [],
      defaultProps: {
        children: "children",
        label: "nodeName",
      },
      treeExpandDate: [],
    };
  },
  methods: {
    onCancel() {
      this.isVisible = false;
    },
    onConfirm() {
      this.loadingBth = true;
      let data = {
        ...this.addForm,
        selectedUserList: this.treeDataValue.filter(v=>v.presetsFlag == 'N').map((v) => v.userId),
      };
      this.$q.qualityTestingManage
        .yoLinkConfigUpdate({ data: data })
        .then((res) => {
          if (res.code == 200) {
            let text = this.title + "成功";
            this.$message.success(text);
            this.isVisible = false;
            this.$emit("success");
          }
        })
        .finally((res) => {
          this.loadingBth = false;
        });
    },
    async init() {},
    // 搜索逻辑
    filterMethod(value) {
      this.$refs.tree.filter(value);
    },
    // tree节点过滤
    filterNode(value, data) {
      if (!value) return true;
      return data.nodeName.indexOf(value) !== -1;
    },
    handleNodeClick(data) {
      // this.addForm.nodeName = data.data.fullPath;
      // this.addForm.orgId = data.data.orgId;
      // this.treeDataValue = data;
      // this.$refs.mySelect.handleClose();
    },
    // 获取组织树结构
    getOrgTree() {
      let params = {
        messageType: this.rowData.messageType,
        orgId: 1,
      };
      this.$q.qualityTestingManage
        .yoLinkOrganUserInfo({ data: params })
        .then(({ data }) => {
          let list = data[0].children;
          console.log(data);
          list.forEach((item) => {
            this.getLeafKeys(item);
          });
          this.nodeData = list;
          console.log(this.treeDataValue);
          this.$nextTick(_=>{
            this.$refs.tree.setCheckedNodes(this.treeDataValue)
          })
        })
        .finally(() => {});
    },
    //递归当前数据将用户列表添加到children里 获取回显值
    getLeafKeys(node) {
      // 如果当前 node 节点不包含 children 属性，则是三级节点
      if (!node.userInfoList || !node.userInfoList.length) {
        // 除了最后一级所有节点disabled为true
        node.disabled = true;
      }

      if (node.userInfoList && node.userInfoList[0] != 0) {
        //处理用户list统一成children格式
        let data = node.userInfoList.map((v) => {
          return {
            ...v,
            nodeName: v.userName + "" + v.workNo,
            disabled: v.presetsFlag == "Y",
            // nodeId: v.orgId,
            userInfoList: ["0"],
          };
        });
        //如果当前子集下全部都是禁用父级也禁用
        if (data.filter((v) => !v.disabled).length) {
          node.disabled = false;
        } else {
          node.disabled = true;
        }
        node.children = [...node.children, ...data];
        let treeDataValue = data.filter(v=>v.selectedFlag == 'Y' && v.presetsFlag == 'N')
        this.treeDataValue = [...this.treeDataValue,...treeDataValue] //获取回显数据
      }
      if (node.children) {
        node.children.forEach((item) => this.getLeafKeys(item));
      }
    },
    labelChange(val) {
      if (val.length) {
        let data = this.treeDataValue.filter((v) => val.includes(v.userName));
        this.treeDataValue = data;
        this.$refs.tree.setCheckedNodes(data);
      } else {
        this.treeDataValue = []
        this.$refs.tree.setCheckedNodes([]);
      }
    },
    checkChange(data) {
      let list = this.$refs.tree.getCheckedNodes();
      list = list.filter((v) => !v.disabled && v.userName);
      let value = list.map((v) => v.userName);
      this.addForm.label = value;
      this.treeDataValue = list;
    },
  },
  created() {
    this.getOrgTree();
    this.addForm = this.rowData;
  },
};
</script>
<style lang="stylus" scoped>
.content {
  max-height: 70vh
  overflow-y: auto
}

>>> .el-tree-node {
    .el-checkbox__input.is-disabled {
        display: none;
    }
}

>>> .el-date-editor, >>> .el-select, >>> .el-input {
  width: 200px !important;
}

// >>> .el-form-item__content .textTips {
//   cursor: pointer
//   overflow: hidden
//   white-space: nowrap;
//   text-overflow: ellipsis
// }
</style>
